#import "./stageset-fragment.graphql"

fragment EntityAttributeEnumFragment on EntityAttributeEnum {
    allowMultiple
    options {
        id
        name
    }
}
